export const TradesImageUrl = `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/information-card/trade_or_sell.jpg`;

export const FinancingImageUrl = `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/information-card/finance.jpg`;

export const GenericImage1 = `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/information-card/generic_1.jpg`;

export const GenericImage = `${process.env.REACT_APP_GCP_STORAGE_BASE_URL}/assets/information-card/vending_machine.jpg`;
